module.exports = __webpack_public_path__ + "static/media/Shop-By-Lic-Plate.024636e5.svg";